import script from "./ChallengeDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChallengeDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ChallengeDetail.vue?vue&type=style&index=0&id=f1252672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1252672"]])

export default __exports__